import Return from './return'
const App = props =>{
  return <>
    <Return {...props} />
  </>
}

export default App